module.exports = __webpack_public_path__ + "img/feliz.3ec02660.png";